/**
* CLASS Moneda
*
* Contiene el contenedor principal de los tipos de Moneda
*
* @author Hector Morales <hector.morales@ikarosofttechnology.com>
*/

import React, { Component } from 'react';
import DataGrid from '../data_grid/DataGrid';
import globalState from '../configuration/GlobalState';
import {cargarFilas} from '../api_calls/ApiCalls';
import TBar from '../tbar/TBar';

class Moneda extends Component {
    retrocederPanel(){
        this.props.funcionClick('PanelMenu');
    }

    async validacionDeleteMoneda(id){
        try{
            // Validar que no hayan contratos con la moneda
            let database = globalState.getState().companyData[0].bd;
            let sqlParams = {
                                sqlCols : [
                                    "COUNT(id) AS total"                                             
                                ],                            
                                sqlWhere : [
                                    " AND id_moneda = "+id//no cuenta superusuarios
                                ],                                      
                            }; 
            let res = await cargarFilas('terceros_contratos','',1000,0,'','',sqlParams,'rows',database);
            let response = res.data; 
            if(response.length > 0 && response[0].total > 0){
                return {  status : false, message : "La moneda no se puede eliminar, tiene contratos vinculados!" }; 
            }
            
            return {  status : true, message : "" }; 
               
        }           
        catch(err){
            return {  status : false, message : 'No se ha logrado la conexion con el servidor!<br />'+err.message }; 
        }     
    }

  	render() {     
        let sqlParams = { 
                            fieldSearch : [
                                'nombre',                                
                            ],                                                        
                            filtroFechas : "false",                                                 
                        };                 
        return (//carga el componente que contiene la grilla de datos 
            <div>
                <TBar
                    items={[
                              {
                                  type : 'boton',
                                  icon : 'arrow_back',
                                  width : '100px',
                                  height : '60px',
                                  title : 'Atras',
                                  display : true,
                                  function : this.retrocederPanel.bind(this)
                              },
                          ]}
                    length = '1'
                />
                <div style={{top: "60px",position:"relative"}}>            
                    <DataGrid titulo='Moneda' 
                              funcionClick={this.props.funcionClick} 
                              funcionBeforeDelete={this.validacionDeleteMoneda.bind(this)}
                              parametro={this.props.parametro}
                              colsData={[ 
                                            {
                                                type  : 'bd',
                                                label : 'Nombre',
                                                field : 'nombre'
                                            },
                                            {
                                                type  : 'bd',
                                                label : 'Nombre en Letras',
                                                field : 'nombre_en_letras'
                                            },
                                            {
                                                type  : 'bd',
                                                label : 'Simbolo',
                                                field : 'simbolo'
                                            },
                                        ]} 
                              sqlParams = { sqlParams }
                              automatica="true"
                              botonNuevo="true"
                              formFields={[
                                            {
                                                label : 'Nombre *',
                                                field : 'nombre',
                                                type  : 'text',
                                                validation : 'mayusculas',
                                                longitud : 30,
                                                required : 'true',
                                                tooltip : 'Ingrese el nombre de la moneda',                                               
                                            },
                                            {
                                                label : 'Nombre en Letras *',
                                                field : 'nombre_en_letras',
                                                type  : 'text',
                                                validation : 'mayusculas',
                                                longitud : 30,
                                                required : 'true',
                                                tooltip : 'Ingrese el nombre en letras',                                               
                                            },
                                            {
                                                label : 'Simbolo *',
                                                field : 'simbolo',
                                                type  : 'text',
                                                validation : '',
                                                required : 'true',
                                                tooltip : 'Ingrese el simbolo',                                               
                                            }                                    
                                        ]}                     
                              apiField={'monedas'}
                              mainContainer='Moneda'/> 
                </div>
            </div>             
        )
    } 
}

export default Moneda